<template>
  <div>
    <div v-if="isActiveTasksChecked && !hasActivePlayable" class="completed">
      <img style="width: 150px;" src="~@/assets/icons/checkGradient.svg" alt="check" />
      <VueText style="margin-top: 20px;" sizeLevel="6" weightLevel="3">
        {{ getPlayableCompletedText }}
      </VueText>
    </div>
    <div v-else-if="isActiveTasksChecked && hasActivePlayable" class="player-wrapper">
      <iframe class="ommaPlayer" :src="getPlayableFactoryUrl" />
    </div>
  </div>
</template>
<script>
import Playable from '@/services/Api/playable';
import VueText from '@/components/shared/VueText/VueText';
import StorageHelper from '@/utils/storageHelper';
import GameApi from '@/services/Api/gamification';
import { getDoAndWinTaskCount } from '@/utils/doAndWinTaskCountHelper';

export default {
  name: 'Playable',
  components: {
    VueText,
  },
  data() {
    return {
      hasActivePlayable: false,
      isActiveTasksChecked: false,
    };
  },
  computed: {
    getPlayableInfo() {
      return new StorageHelper({
        id: 'PlayableInfo',
      }).get();
    },
    getPlayableFactoryUrl() {
      return this.getPlayableInfo.referralLink;
    },
    getPlayableCompletedText() {
      return 'Oyun Yap Kazanı Tamamladınız';
    },
  },
  mounted() {
    this.loadScriptFunc();
    this.checkActiveTasks();
  },
  methods: {
    async loadScriptFunc() {
      const taskInfo = this.getPlayableInfo;
      window.onmessage = async function(e) {
        if (e.data.type == 'pf_event') {
          const eventName = e.data.name;
          if (eventName == 'start' || eventName == 'end' || eventName == 'cta') {
            const request = {
              totalDuration: 0,
              playDuration: e.data.time,
              status:
                eventName == 'start' ? 1 : eventName == 'cta' ? 4 : eventName == 'end' ? 3 : 2,
              success: eventName == 'end' ? !!e.data.value : false,
              isLinkClicked: eventName == 'cta' ? true : false,
              taskId: taskInfo?.taskId,
            };
            await Playable.playableSaveLog(request);
            getDoAndWinTaskCount();
          }
        }
      };
    },
    async checkActiveTasks() {
      const taskInfo = this.getPlayableInfo;

      try {
        const result = await GameApi.getDoWinTasks(true);
        const inCompletedTasks = result?.data?.Data?.inCompletedTasks || [];

        this.hasActivePlayable = inCompletedTasks.some(task => task.taskId === taskInfo?.taskId);
        this.isActiveTasksChecked = true;
      } catch (error) {
        this.isActiveTasksChecked = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.completed {
  text-align: center;
  position: absolute;
  left: 30%;
  top: 30%;
}
.player-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
  .ommaPlayer {
    position: absolute;
    width: 90%;
    height: 90%;
    left: 5%;
  }
}
</style>
